import React, { useState, useEffect } from "react";
// https://react-bootstrap.github.io/components/cards/#card-columns
import { CardColumns, Card } from "react-bootstrap";
import { filteredProjects, projectData } from "../../data";
import {
  ProjectsError,
  ProjectsLoading,
} from "../components/projectsLoadingError";

// Image
import defualtImage from "../images/logo.svg";

const Projects = ({ theme, githubUsername }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const githubUrl = `https://api.github.com/users/${githubUsername}/repos`;

  useEffect(() => {
    fetch(githubUrl)
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        } else {
          setIsError(true);
          setIsLoading(false);
          setError(response.statusText);
          throw new Error(response.statusText);
        }
      })
      .then((data) => {
        let check = false;
        if (filteredProjects.length !== 0) {
          let tempObj = {};
          data.forEach((element, index) => {
            tempObj[element.name] = index;
          });
          check = filteredProjects.every((element) => {
            return tempObj[element] !== undefined;
          });
        }
        if (check) {
          let newData = data.filter((projects) =>
            filteredProjects.includes(projects.name)
          );
          if (projectData.length === filteredProjects.length) {
            for (let i = 0; i < projectData.length; i++) {
              newData[i].imageInfo = projectData[i];
            }
          }
          setData(newData);
          setIsLoading(false);
        } else {
          setData(data);
          setIsLoading(false);
        }
      })
      .catch((error) => console.log(error));
  }, [githubUrl]);

  const newTheme = `${theme} d-flex flex-column min-vh-100 justify-content-center align-items-center text-center`;

  // if (isLoading) {
  //   return <ProjectsLoading theme={theme} />;
  // }

  // if (isError) {
  //   return <ProjectsError theme={theme} error={error} />;
  // }

  // There MUST be one image per repo (see projectData.js)
  // if (data.length === projectData.length) {
  //   return (
  //     <section id="projects" className={newTheme}>
  //       <div className="container">
  //         <h2>Projects</h2>
  //         <hr />
  //         <CardColumns>
  //           {data.map((projects) => {
  //             return (
  //               <Card key={projects.id}>
  //                 <Card.Img
  //                   variant="top"
  //                   src={projects.imageInfo.image}
  //                   alt="Project Image"
  //                 />
  //                 <Card.Body>
  //                   <a
  //                     href={projects.html_url}
  //                     target="_blank"
  //                     rel="noreferrer"
  //                   >
  //                     <Card.Title className="d-inline-block">
  //                       {projects.name}
  //                     </Card.Title>
  //                   </a>
  //                 </Card.Body>
  //               </Card>
  //             );
  //           })}
  //         </CardColumns>
  //       </div>
  //     </section>
  //   );
  // }

  return (
    <section id="projects" className={newTheme}>
      <div className="container text-center">
        <h2>Projects</h2>
       
<p>
These are a few personal projects I've been working on recently.
</p>
  </div>
  <div className="container text-left">

  <hr />
<h5>Multiplayer Quiz-Night Game in Unity Engine. April 2022.</h5>

<p>
Last year with React Native I made a prototype for a multiplayer tvOS game based around a trivia game show (think The Chase) where players can use their phones as controllers to race each other to select multiple choice trivia questions.
</p>
<p>
I figured this was the perfect project to use to learn Unity and C#. This time round I decided to use a Laravel backend and Pusher for managing websockets.
</p>
<p>
The project picked up a few new features along the way, such as secure sockets, user accounts to ensure you are never asked the same question twice, menus, music and sound effects.
But, it's still a long way off completion! I'm hoping to get some free time to return to this project to improve the game visually with some animations and stuff, which was kind of the point of using Unity, really!
</p>
<p>
It is a short-mid term goal of mine to get this game into the app stores!
</p>
<hr />
<h5>Demoscene Visualisations. May 2021.</h5>

<p>
Recently while working on a coding challenge that involved rendering colour palletes at certain bit-depths, I stumbled onto some striking pattern renders and decided to make a browser based 'Demo' scene in javascript. I came up with a handful of scenes and started working on some logic to build them into one piece of art. It's a bit of light-hearted fun demonstrating the power of HTML5 canvas.
</p>

<a href="https://jpmc3630.github.io/funfunfun/" target="_blank" rel="noreferrer">
Live Demo
</a>




<hr />
<h5>Map Tile Server hosted on AWS. May 2021.</h5>
<p>
Recently a friend came to me with an emerging dilemma. They had built a data visualisation project and released it to Reddit. It then spread to facebook and went viral. After just 2 hours of going live, the app was getting around ten thousand visitors per hour. The problem was that the data was visualised on a map, which was built using the MapBox SDK, and relied on the MapBox API to serve the map tiles. The site had already exceeded the 50'000 free map tiles per month, and was chewing through about 100'000 tile requests per hour, at a cost of $5 per ten thousand. The app was a free data project and generated no revenue - there was no budget - and my friend thought he would have to close project down right as it was in it's prime.
</p>
<p>
I wrote a bash script that automated spinning up a map server instance. It installed a docker image of an open source tile server, fetched appropriate maps for our region, configured Nginx and installed an SSL certificate. The servers were deployed on an AWS cluster of EC2 instances, and within a few hours a solution was up and running that cost next to nothing. We were serving beautiful vector maps, super fast, and had raster maps as fall back for older mobile devices.
</p>





<hr />
<h5>Interactive LED screen at arts festival. April 2021.</h5>

<p>
This was an interactive LED screen for an arts festival at regional Burning Man event. 
The concept was to distribute QR codes around the festival, to give people access to a web interface 
that allowed them to post messages in real time to a giant LED screen. 
This turned out to be a pretty complicated project, and about as full stack as it gets. 
</p>
<p>
  
  Firstly it involved building a controller to drive a giant LED matrix I bought auction, by modifying a community driven C++ library, and running it on a Raspberry Pi. 
  It took a lot of hacking to get the HUB75A standard LED driver library to work with our screen. 
  Including building a wiring harness, a custom multiplexer to get the screen to display correctly, and a custom pixel mapper to use the screen in the appropriate orientation!
  I wrote a NodeJS program on the Pi to connect to a web server and maintain a websocket connection and handle the communications between the web interface and the hardware running off the Pi. 
  </p>
  <p>
  So there were three parts, the code running on the Pi, the web server, and the web interface. 
  The screen was connected via a Telstra pre-paid sim card (with no addressable IP), in regional WA, outdoors, in weather, running off a generator. 
  The project was a success, it generated a lot of public interest, had hundreds of messges posted and was considered a valuable contribution to the arts festival.
</p>
<a href="https://github.com/jpmc3630/bs-screen" target="_blank" rel="noreferrer">
Raspberry Pi NodeJS Repo
</a><br></br>
<a href="https://github.com/jpmc3630/blazing-marquee" target="_blank" rel="noreferrer">
NodeJS Webserver and ReactJS Web Interface Repo
</a>




<hr />
<h5>Mutliplayer online tvOS/mobile trivia game. February 2021.</h5>


<p>
 This is a multiplayer party game that allows players to use their own phones and mobile internet connections via browser to connect to a game created by a tvOS app. The game is intialised by the TV and a code is shown on the screen, which users enter into a web site, and join the game. I was exploring the options for Apple/AndroidTV and built a prototype using NodeJS for the game server, React Native for tvOS for the TV part, and ReactJS for the website players use to connect to the game and play along asnwering the questions displayed on the TV.
</p>

<p>
I got this to working prototype stage, but have decided to remake the tvOS part using Unity game engine. The main reason for this, is that at the end of the day, the game lacks visual charm. The trivia aspect is fun, but I didn't see it as worthwile to spend many hours trying to jazz up a fairly bland React-Native interface on a tv screen! I decided it would be a more fruitful pursuit to build the game in Unity, as it would ultimately look alot better, future proof my code base to a large extent, and also make it cross platform with some minimal changes for input controls. This is an ongoing project.
</p>

<a href="https://github.com/jpmc3630/tvos-trivia" target="_blank" rel="noreferrer">
tvOS App Repo
</a>
<br></br>
<a href="https://github.com/jpmc3630/tvtrivia/" target="_blank" rel="noreferrer">
NodeJS Game Server and ReactJS Webserver Repo
</a>

      </div>
      <br></br>
      <br></br>
    </section>
    
  );
};

export default Projects;
